<template>
  <div class="elevation-3 mt-n2 ma-3 pa-1 pb-5">
    <v-row>
      <v-col cols="7" class="mt-3">
        <!-- <p class="font-weight-light mb-0 input-text-size
          pt-1 pl-1">Payments Records : </p> -->
        <TaxRollPayments getHeight="100" />
        <div class="d-flex align-center justify-space-between mt-3">
          <p class="font-weight-light input-text-size mb-0">Delinquent Tax Records : </p>
          <v-btn
            class="input-text-size ml-2"
            small
            text
            color="primary"
            @click="handleDelinquentAction"
            :disabled="!selectedRowData || Object.keys(selectedRowData).length === 0"
          >
            Add all to Picklist
          </v-btn>
        </div>
        <TaxRollDelq class="mt-n4" />
      </v-col>
      <v-col cols="5">
        <template v-if="checkIfThereIsMobileHome">
          <p class="font-weight-light mb-0 input-text-size pt-n1">Legal Description :</p>
          <p class="input-text-size dec-line-height" style="color: #ff0000 !important;
            font-weight: bold !important;">MOBILE HOME</p>
          <v-textarea class="input-text-size pa-0 mb-n4 mt-n3 dec-line-height" rows="4"
            readonly :value="legalNSitusVal()"/>
        </template>
        <v-textarea v-else class="input-text-size mb-n5 dec-line-height"
         :value="legalNSitusVal()" rows="6" readonly label="Legal Description :"
         v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
        <div class="d-flex align-center justify-space-between">
        <span class="font-weight-light mb-0 input-text-size pt-1 pl-1">Comments : </span>
        <v-icon
          @click="addNewComments"
          color="primary"
          class="mr-4"
        >
          {{ icons.mdiPlus }}
        </v-icon>
        </div>
        <TaxRollComments />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { mdiPlus } from '@mdi/js';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import TaxRollComments from '../taxrollSearch/SubComponents/TaxRollComments.vue';
import TaxRollDelq from '../taxrollSearch/SubComponents/TaxRollDelq.vue';
import TaxRollPayments from '../taxrollSearch/SubComponents/TaxRollPayments.vue';
import '../../../../assets/style.css';

export default {
  name: 'OwnerFooter',
  mixins: [GlobalToCaps],
  data() {
    return {
      icons: {
        mdiPlus,
      },
    };
  },
  props: {
    selectedRowData: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    TaxRollComments,
    TaxRollPayments,
    TaxRollDelq,
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),
    checkIfThereIsMobileHome() {
      if (Number(this.selectedRowData.mobileHome || 0) > 0) return true;
      return false;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setSelectedTab',
    ]),
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertPickListSingleNMultiplipleHybrid',
      'loadTabsAdjustments',
    ]),
    async handleDelinquentAction() {
      const selectedItem = this.items('TaxRollDelq');
      if ((selectedItem || []).length !== 0) {
        const multipleIds = selectedItem.map((it) => it._id);
        this.wkstNumber = getWorkstationNumber();
        const pickListProfileName = localStorage.getItem('pick-list-profile-name');
        const item = {
          mutipleIds: multipleIds,
          addUnpaids: this.paymentSettingItem.loadUnpaidsAutomatically || false,
        };
        // if profile name is present then use it otherwise use workstation
        if (pickListProfileName) item.profileName = pickListProfileName;
        else item.workstation = Number(this.wkstNumber);
        await this.UpsertPickListSingleNMultiplipleHybrid({
          item,
          baseCrudKey: 'pickListTable',
        });
      }
    },
    addNewComments() {
      this.$emit('addNewComments');
    },
    legalNSitusVal() {
      let legalStr = '';
      let situsStr = 'Property Address : ';
      if (this.selectedRowData.legalDesc) legalStr = `Legal Description : ${this.selectedRowData.legalDesc}`;
      if (this.selectedRowData.situsAddress && Number(this.selectedRowData.situsAddress) !== 0) { situsStr += `${this.selectedRowData.situsAddress}\n`; } else { situsStr += '\n'; }
      const combinedString = `${situsStr}${legalStr}`;
      return combinedString;
    },
  },
};
</script>
